import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import axios from 'axios';
import cc from 'classcat';
import dayjs from 'dayjs';
import LS from 'utils/bom-dom-manipulation/local-storage';
import { ModalWidth } from 'utils/constants/app/ui';
import { MILLISECONDS_IN_SECOND } from 'utils/constants/dateInfo/time-numbers';
import SpringConfigs from 'utils/constants/swarm/spring-configs';
import { storageKeyName } from 'utils/generic/storage-key-name';
import { isMobile } from 'utils/is-mobile';
import { Modal } from 'components/Modal';
import {
  SportNft,
  TSportNft
} from 'newcomponents/Shared/sportsbook/SportNFTsModal/SportNft';
import { SwiperSlider } from 'newcomponents/UI/SwiperSlider';
import { getIsLoggedIn, getUser } from 'store/selectors/user-data';
import './index.less';

const ORTAK_GET_USER_GIFTS_API = 'https://ortak.me/panel/giftApi/getUserGifts';

export const SportNFTsModal = () => {
  const isLoggedIn = useSelector(getIsLoggedIn);
  const user = useSelector(getUser);

  const [sportNfts, setSportNfts] = useState<TSportNft[] | null>(null);

  useEffect(() => {
    const currentTimestamp = Number(dayjs().unix()) * MILLISECONDS_IN_SECOND;
    const getUserGiftsSentTimestamp = JSON.parse(
      LS.getItem(storageKeyName('sportsbook', 'GET_USER_GIFTS_SENT_TIMESTAMP'))
    );

    const lastRequestTimestamp =
      Number(getUserGiftsSentTimestamp) * MILLISECONDS_IN_SECOND;

    const isDifferenceGreaterThanOneDay =
      dayjs(currentTimestamp).diff(dayjs(lastRequestTimestamp), 'day') >= 1;

    const shouldRequestData =
      !getUserGiftsSentTimestamp || isDifferenceGreaterThanOneDay;

    if (isLoggedIn && shouldRequestData) {
      try {
        const fetchData = async () => {
          const data = await axios.post(ORTAK_GET_USER_GIFTS_API, {
            partnerId: SpringConfigs.PARTNER_ID,
            externalId: user.id,
            langId: SpringConfigs.CURRENT_LANGUAGE_PREFIX
          });

          const response: TSportNft[] = data?.data?.Data;

          if (response.length) {
            setSportNfts(response);
          } else {
            setSportNfts([]);
          }
        };

        fetchData();
      } catch {
        setSportNfts([]);
      }
    }
  }, [isLoggedIn]);

  const handleModalClose = () => {
    LS.setItem(
      storageKeyName('sportsbook', 'GET_USER_GIFTS_SENT_TIMESTAMP'),
      String(dayjs().unix())
    );

    setSportNfts([]);
  };

  if (!sportNfts?.length) {
    return null;
  }

  return (
    <Modal
      wrapperContainerPadding={'0px'}
      onCancel={handleModalClose}
      className={cc([
        'sportNftsModal',
        { 'sportNftsModal--mobile': isMobile() }
      ])}
      maxWidth={isMobile() ? ModalWidth.MOBILE_350 : ModalWidth.DESKTOP_720}
      visible={!!sportNfts.length}
    >
      <SwiperSlider
        showIndicators={sportNfts.length > 1}
        activeSlide={0}
        spaceBetween={12}
        slidesPerView={1}
        bodyArrows
        drawableTabs={sportNfts.map(nftData => (
          <SportNft key={nftData.externalId} sportNft={nftData} />
        ))}
      />
    </Modal>
  );
};
